import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Helmet } from 'react-helmet-async';
import { JsonLd } from './components/seo/JsonLd';
import { buildWebApplicationSchema } from './utils/schema';
import { Analytics } from './components/common/Analytics';
import { CookieConsent } from './components/common/CookieConsent';

import LandingPage from '@/pages/LandingPage';
import AppPage from '@/pages/AppPage';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import AuthActionPage from '@/pages/AuthActionPage';
import { UpdatePrompt } from '@/components/common/UpdatePrompt';

export function App() {
  const schemaData = buildWebApplicationSchema();

  return (
    <>
      <Helmet>
        <title>ResumePro — AI Resume & Cover Letter Tailoring</title>
      </Helmet>
      <JsonLd data={schemaData} />
      
      <Analytics />
      <Layout>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<AppPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/auth-action" element={<AuthActionPage />} />
        </Routes>
      </Layout>
      <CookieConsent />
      <UpdatePrompt />
    </>
  );
}
